import {defaultFabricante} from '../../fabricantes/state';

export const product = () => {
    return {
        id: null,
        slq_company_id: null,
        name: '',
        sys_list_state_id: null,
        prod_manufacturer_id: null,
        raw_materials: [],
        company: {},
        dl_cl: {},
        classification_date: null,
        document_design_date: null,
        classifications: [],
        grouped_classifications: [],
        properties: {
            id: null,
            cal_product_id: null,
            color: null,
            smell: null,
            melting_point: null,
            freezing_point: null,
            boiling_point: null,
            inflammability: null,
            lower_explosion_limit: null,
            upper_explosion_limit: null,
            flash_point: null,
            autoignition_temperature: null,
            decomposition_temperature: null,
            ph: null,
            kinematic_viscosity: null,
            dynamic_viscosity: null,
            solubility: null,
            vapor_pressure: null,
            relative_density: null,
            relative_vapor_density: null,
            particle_characteristics: null,
            heat_value: null,
            particle_size: null,
            volatile_organic_compound_content: null,
            softening_point: null,
            pour_point: null,
            apparent_density: null,
            volatility_percentage: null,
            saturated_vapor_concentration: null,
            molecular_weight: null,
            molecular_formula: null,
            acid_alkaline_reserve: null,
            octanol_water_partition_coefficient: null,
            bioconcentration_factor: null,
            dbo5: null,
            dqo: null
        },
        type: 'P'
    };
};

export const rawMaterial = () => {
    return {
        id: null,
        cal_product_id: null,
        raw_material_id: null,
        percentage: 0,
        type: 'RM',
        raw_material: {
            id: null,
            name: null,
            components_product: []
        },
    };
};

export const component = () => {
    return {
        id: null,
        code_cas: '',
        name: '',
        pivot: {
            cal_component_id: null,
            cal_product_id: null,
            reported_percentage: null,
            final_percentage: null,
            omit_in_composition: 0
        }
    };
};

export const component_product = () => {
    return {
        cal_component_id: null,
        cal_product_id: null,
        reported_percentage: null,
        omit_in_composition: 0,
        omit_in_carcinogens: 0,
        add_dl_50_oral: 0,
        add_dl_50_cutaneous: 0,
        add_cl_50_inhalation: 0,
        add_cl_50_fish: 0,
        add_ce_50_crustaceans: 0,
        add_cer_50_algae: 0,
        add_cseo_fish: 0,
        add_cseo_crustaceans: 0,
        add_cseo_algae: 0
    };
};

export const newComponent = () => {
    return {
        slq_company_id: null,
        code_cas: null,
        name: null,
        sga: [],
        sga_categories: []
    };
};

export const componentDlCl = () => {
    return {
        id: null,
        code_cas: null,
        name: null,
        dl_cl: {
            dl_50_oral: null,
            dl_50_cutaneous: null,
            cl_50_inhalation: null,
            sys_measure_unit_cl_50_id: null,
            ce_50_crustaceans: null,
            cl_50_fish: null,
            cer_50_algae: null,
            cseo_crustaceans: null,
            cseo_fish: null,
            cseo_algae: null
        },
    };
};

export const filters = () => {
    return {
        company_id: null,
        name: '',
        manufacturer_id: null,
        type: 'P',
        page: 1,
        per_page: 15,
        paginate: true
    };
};

export const paramsRawMaterials = () => {
    return {
        company_id: null,
        name: '',
        manufacturer_id: null,
        type: 'RM',
        page: 1,
        per_page: 10,
        paginate: true
    };
};

export const classification = () => {
    return {
        classified: 0,
        has_values: 0,
        value: 0,
        cal_product_id: null,
        additional_text: null,
        danger_class_list_id: null,
        category: null,
        sub_category: null,
        slq_sga_category_id: null,
        module_list_id: null,
        pictogram_sga_id: null,
        pictogram_un_id: null,
        word_of_warning: null,
        order: 1,
        index_questions: 0,
        danger_class_list: {},
        sga_categories: [],
        module_list: {},
        pictogram_sga: {},
        pictogram_un: {},
        classifications: []
    };
};

export const file = () => {
    return {
        type: 'file',
        cal_product_file_id: null,
        cal_product_id: null,
        temporary_url: null,
        file_name: null,
        original_name: null,
        extension: null,
        file: null,
        parent: {}
    };
};

export const folder = () => {
    return {
        type: 'folder',
        cal_product_file_id: null,
        cal_product_id: null,
        original_name: null,
        parent: {}
    };
};

/**
 * Contiene la definición inicial para el objeto fabricante
 * @returns {{ocultar_productos: boolean, direccion: string, telefono_de_emergencia: string, telefono: number, nombre: string}}
 */
export const manufacturer = () => {
    return {
        nombre: '',
        direccion: '',
        telefono: '',
        telefono_de_emergencia: '',
        ocultar_productos: false
    }
}

export default {
    product: product(),
    product_classifications: product(),
    raw_material: rawMaterial(),
    component: component(),
    component_product: component_product(),
    new_component: newComponent(),
    component_dl_cl: componentDlCl(),
    raw_materials: {data: []},
    measure_units_cl_50: [],
    manufacturers_filters: [],
    companies_filters: [],
    companies: [],
    manufacturers: [],
    categories: [],
    components: [],
    module_code: null,
    code_question_group: null,
    action: 'Crear',
    action_raw_material: 'Crear',
    action_component: 'Crear',
    action_new_component: 'Crear',
    products: {data: []},
    filters: filters(),
    modal: {show: false},
    modal_raw_material: {
        show: false,
        action: 'c' // c: create, a: add, u: update
    },
    modal_wizard: {show: false, step: 0},
    modal_raw_materials: {
        show: false,
        params: paramsRawMaterials(),
    },
    modal_components: {show: false},
    modal_component: {show: false},
    modal_new_component: {
        show: false,
        action: 'c' // c: create, u: update
    },
    modal_definitions: {show: false},
    modal_dl_cl: {show: false},
    question_groups: [],
    answers: [],
    definitions: [],
    index_to_show: 0,
    components_iarc: [],
    set_answers: true,
    danger_classes: [],
    danger_categories: [],
    modules: [],
    only_view: false,
    classification: classification(),
    questions_index: 0,
    grouped_components: [],
    totals: [],
    pictograms: [
        {
            'id': 1,
            'imagen': 'BOMBA_EXPLOTANDO.png',
            'pictograma': 'BOMBA_EXPLOTANDO',
        },
        {
            'id': 2,
            'imagen': 'LLAMA.png',
            'pictograma': 'LLAMA',
        },
        {
            'id': 3,
            'imagen': 'LLAMA_SOBRE_CIRCULO.png',
            'pictograma': 'LLAMA_SOBRE_CIRCULO',
        },
        {
            'id': 4,
            'imagen': 'BOTELLA_DE_GAS.png',
            'pictograma': 'BOTELLA_DE_GAS',
        },
        {
            'id': 5,
            'imagen': 'CORROSION.png',
            'pictograma': 'CORROSION_FISICO',
        },
        {
            'id': 6,
            'imagen': 'CALAVERA_Y_TIBIAS_CRUZADAS.png',
            'pictograma': 'CALAVERA_Y_TIBIAS_CRUZADAS',
        },
        {
            'id': 7,
            'imagen': 'SIGNO_DE_EXCLAMACION.png',
            'pictograma': 'EXCLAMACION_NOCIVO',
        },
        {
            'id': 8,
            'imagen': 'CORROSION.png',
            'pictograma': 'CORROSION_SALUD',
        },
        {
            'id': 9,
            'imagen': 'SIGNO_DE_EXCLAMACION.png',
            'pictograma': 'EXCLAMACION_IRRITANTE',
        },
        {
            'id': 10,
            'imagen': 'PELIGRO_PARA_LA_SALUD.png',
            'pictograma': 'PELIGRO_PARA_LA_SALUD',
        },
        {
            'id': 11,
            'imagen': 'AMBIENTE.png',
            'pictograma': 'MEDIO AMBIENTE',
        },
        {
            'id': 12,
            'imagen': 'SIGNO_DE_EXCLAMACION.png',
            'pictograma': 'EXCLAMACION_AMBIENTE',
        }
    ],
    states: [
        {
            id: 131,
            text: 'Solido',
        },
        {
            id: 132,
            text: 'Liquido',
        },
        {
            id: 133,
            text: 'Gaseoso',
        },
    ],
    files: [],
    modal_file: {show:false},
    modal_preview: {show:false},
    modal_name: {show:false, creating: true},
    modal_converter: {show:false},
    modal_manufacturer: {show:false},
    file: file(),
    folder: folder(),
    manufacturer: manufacturer(),
    mode: 2,
    raw_material_temp: null
};
